/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Waiting_Reason_Dialog_TitleInputs */

const en_task_waiting_reason_dialog_title = /** @type {(inputs: Task_Waiting_Reason_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why is this waiting?`)
};

const pt_br2_task_waiting_reason_dialog_title = /** @type {(inputs: Task_Waiting_Reason_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que está aguardando?`)
};

/**
* | output |
* | --- |
* | "Why is this waiting?" |
*
* @param {Task_Waiting_Reason_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_waiting_reason_dialog_title = /** @type {((inputs?: Task_Waiting_Reason_Dialog_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Waiting_Reason_Dialog_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_waiting_reason_dialog_title(inputs)
	return pt_br2_task_waiting_reason_dialog_title(inputs)
});